import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import basePath from '../../utils/basePath';
import AppBar from 'material-ui/AppBar';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import List, { ListItem, ListItemText } from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import Drawer from 'material-ui/Drawer';

import logo from '../../../image/logoprocut.png';

export class Header extends Component {
  constructor() {
    super();
    this.state = {
      currentPage : 'Home',
      drawerState: false,
    }
    this.onHomeClick = this.onHomeClick.bind(this);
    this.onProductsClick = this.onProductsClick.bind(this);
    this.onAboutUsClick = this.onAboutUsClick.bind(this);
    this.onContactUsClick = this.onContactUsClick.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  componentWillMount() {
    switch(window.location.pathname) {
      case("/products") :
      this.setState({currentPage:'Products'})
      break;

      case("/auto-trolly-machine") :
      this.setState({currentPage:'Products'})
      break;

      case("/eco-top") :
      this.setState({currentPage:'Products'})
      break;

      case("/aboutus") :
      this.setState({currentPage:'About Us'})
      break;

      case("/contactus") :
      this.setState({currentPage:'Contact Us'})
      break;

      default:
      this.setState({currentPage:'Home'})
    }
  }

  onHomeClick() {
    if(this.state.drawerState) {
      this.toggleDrawer(false)
    }
    this.setState({currentPage:'Home'})
  }

  onProductsClick() {
    if(this.state.drawerState) {
      this.toggleDrawer(false)
    }
    this.setState({currentPage:'Products'})
  }

  onAboutUsClick() {
    if(this.state.drawerState) {
      this.toggleDrawer(false)
    }
    this.setState({currentPage:'About Us'})
  }

  onContactUsClick() {
    if(this.state.drawerState) {
      this.toggleDrawer(false)
    }
    this.setState({currentPage:'Contact Us'})
  }

  toggleDrawer(open) {
    this.setState({drawerState: open});
  }

  render() {
    const currentPage = this.state.currentPage;
    return (
      <div>
      <div>
        <AppBar position="static" color="default" className="header_wrapper">
          <Grid container className="header_container">
            <Grid item md={4} sm={5} xs={5} className="header_logo"> 
              <Link to={basePath``} onClick={() => this.onHomeClick()}>
                <img src={logo} alt="logo" />
              </Link>
            </Grid>
            <Grid item md={8} className="header_navigation_web"> 
              <List className="list-wrapper">
                <Link to={basePath``} onClick={() => this.onHomeClick()}>
                  <ListItem button className={currentPage === 'Home' ? "selected-title" : ""} divider={currentPage === 'Home' ? true : false}>
                    Home
                  </ListItem>
                </Link>
                <Link to={basePath`products`} onClick={() => this.onProductsClick()}>
                  <ListItem button className={currentPage === 'Products' ? "selected-title" : ""} divider={currentPage === 'Products' ? true : false}>
                    Products
                  </ListItem>
                </Link>
                <Link to={basePath`aboutus`} onClick={() => this.onAboutUsClick()}>
                  <ListItem button className={currentPage === 'About Us' ? "selected-title" : ""} divider={currentPage === 'About Us' ? true : false}>
                    About Us
                  </ListItem>
                </Link>
                <Link to={basePath`contactus`} onClick={() => this.onContactUsClick()}>
                  <ListItem button className={currentPage === 'Contact Us' ? "selected-title" : ""} divider={currentPage === 'Contact Us' ? true : false}>
                    Contact Us
                  </ListItem>
                </Link>
              </List>
            </Grid>
            <Grid item xs={7} className="header_navigation_mobile">
              <Grid container> 
                <Grid item xs={8} className="page-title">
                  <Typography type="title">
                    {currentPage}
                  </Typography>
                </Grid>
                <Grid item xs={4} className="menu-icon">
                  <IconButton color="primary" aria-label="Menu" onClick={() => this.toggleDrawer(true)}>
                    <MenuIcon />
                  </IconButton>
                </Grid>
              </Grid> 
            </Grid>
          </Grid>
        </AppBar>
        </div>
        <Drawer className="drawer-top" onClose={() => this.toggleDrawer(false)} anchor="top" type="temporary" open={this.state.drawerState}>
          <div>
            <List>
              <Link to={basePath``} onClick={() => this.onHomeClick()}>
                <ListItem button divider className={currentPage === 'Home' ? "selected-title-mobile" : ""}>
                  <ListItemText primary="Home" />
                </ListItem>
              </Link>  
              <Link to={basePath`products`} onClick={() => this.onProductsClick()}>
                  <ListItem button divider className={currentPage === 'Products' ? "selected-title-mobile" : ""}>
                    <ListItemText primary="Products" />
                  </ListItem>
                </Link>
                <Link to={basePath`aboutus`} onClick={() => this.onAboutUsClick()}>
                  <ListItem button divider className={currentPage === 'About Us' ? "selected-title-mobile" : ""}>
                    <ListItemText primary="About Us" />
                  </ListItem>
                </Link>
                <Link to={basePath`contactus`} onClick={() => this.onContactUsClick()}>
                  <ListItem button divider className={currentPage === 'Contact Us' ? "selected-title-mobile" : ""}>
                    <ListItemText primary="Contact Us" />
                  </ListItem>
                </Link>
            </List>
          </div>
        </Drawer>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commons/ui/components/Header.js